import type { ReactNode } from 'react'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { PrimaryButton } from 'shared/components/button'
import FormInputSearch from 'shared/components/form-input-search'
import SearchIcon from 'shared/icons/search-icon'
import type {
  CourseEnrollmentsFilterInterface,
  SchoolCommonEnrollmentsDataInterface,
} from '../types/school-enrollments-interface'

export const defaultFilter: CourseEnrollmentsFilterInterface = {
  searchBy: '',
}

export interface EnrollmentsTabFilterProps {
  className?: string
  inputClassName?: string
  filter: CourseEnrollmentsFilterInterface
  setFilter: (arg: React.SetStateAction<CourseEnrollmentsFilterInterface>) => void
}

export const EnrollmentsTabFilter = ({
  className,
  inputClassName,
  filter,
  setFilter,
}: EnrollmentsTabFilterProps): ReactNode => {
  const [nameFilter, setNameFilter] = useState<SchoolCommonEnrollmentsDataInterface['name']>(
    filter.searchBy,
  )

  const { t } = useTranslation()

  return (
    <form className={`justify-end gap-5 ${className || 'flex'}`}>
      <FormInputSearch
        key={'name-filter'}
        data-test-id="input-search-school-name"
        inputClassName={inputClassName}
        placeholder={t('global.search')}
        onClear={() => setNameFilter('')}
        value={nameFilter}
        onChange={e => setNameFilter(e.target.value)}
      />
      <PrimaryButton
        type="submit"
        onClick={e => {
          e.preventDefault()
          setFilter(prev => ({ ...prev, searchBy: nameFilter }))
        }}
        className="flex items-center"
        data-test-id="button-school-search"
      >
        <SearchIcon className="size-[15px] stroke-background-secondary" />
        <span className="hidden font-bold sm:block"> {t('global.search')}</span>
      </PrimaryButton>
    </form>
  )
}
